import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Sidebar from "../Sidebar";
import Header from "../Header";
import DeveloperHome from "../../pages/Developer/Home";

const developerLinks = [
  { to: "/developer/home", label: "Home" },
];

export default function DeveloperLayout() {
  return (
    <div className="ae-shell">
      <Sidebar links={developerLinks} />
      <div className="ae-shell-content">
        <Header />
        <main className="ae-shell-main">
          <Routes>
            <Route path="home" element={<DeveloperHome />} />
            <Route path="*" element={<Navigate to="home" />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
